import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      © {currentYear} <a href="http://bernardompita.com/">Bernardo Pita</a>,
      developed by{" "}
      <a href="http://sergie.net/" target="_blank">
        Sergie Arruda
      </a>
    </footer>
  );
};

export default Footer;
